import { render } from "./ClasificationEditPage.vue?vue&type=template&id=2b41ade6"
import script from "./ClasificationEditPage.vue?vue&type=script&lang=js"
export * from "./ClasificationEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__